import { atom } from "recoil";
import HostingModel from "../Models/HostingModel";
export const SaleHostingState = atom({
  key: "SaleHostingState",
  default: new HostingModel(),
});
